import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Sessions from "./pages/Sessions";
import SessionDetails from "./pages/SessionDetails";

import PrivateRoute from "./components/PrivateRoute";

function App() {

    return (

        <BrowserRouter>

            <Routes>

                <Route path="/login" element={<Login />} />

                <Route
                    path="/"
                    element={
                        <PrivateRoute>
                            <Sessions />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/session/:uuid"
                    element={
                        <PrivateRoute>
                            <SessionDetails />
                        </PrivateRoute>
                    }
                />

            </Routes>

        </BrowserRouter>

    );

}

export default App;